import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import React, { useMemo } from "react";
import { CMSearchResultCellFrame } from "../CMSearchResultCellFrame/CMSearchResultCellFrame";
import {
  Box,
  Center,
  ComponentMultiStyleConfig,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { isNullish } from "../../../../lib/util/common-util";

export type CMSearchResultCellNotificationBadgeProps = {
  value?: boolean | number;
} & ComponentStyleProps;

export const CMSearchResultCellNotificationBadge = ({
  value,

  sx,
  ...rest
}: CMSearchResultCellNotificationBadgeProps) => {
  const styles = useMultiStyleConfig(
    "CMSearchResultCellNotificationBadgeStyles",
  );

  const containerStyles = useMemo(
    () => ({ ...styles.container, ...sx }),
    [styles.container, sx],
  );

  return (
    <CMSearchResultCellFrame sx={containerStyles} {...rest}>
      <Center>
        {isNullish(value) || value === false || value <= 0 ? (
          <></>
        ) : typeof value === "number" ? (
          <Center sx={styles.content}>
            <Box>{value}</Box>
          </Center>
        ) : (
          <Box sx={styles.content}></Box>
        )}
      </Center>
    </CMSearchResultCellFrame>
  );
};

export const CMSearchResultCellNotificationBadgeStyles: ComponentMultiStyleConfig =
  {
    parts: ["container", "content"],
    baseStyle: {
      container: {},
      content: {
        minW: "16px",
        h: "16px",
        px: "2px",
        py: "0",

        alignItems: "center",

        bgColor: "red.400",
        borderRadius: "100px",

        fontSize: "xs",
        color: "white",
      },
    },
  };
